
export default {
    setColumns(state, columns) {
        state.columns = columns;
    },

    setSortedColumns(state, sortedColumns) {
        state.sortedColumns = sortedColumns;
    },

    setFixedColumns(state, fixedColumns) {
        state.fixedColumns = fixedColumns;
    },

    pushFixedColumn(state, fixedColumn) {
        let list = state.fixedColumns.slice(0);
        list.push(fixedColumn);
        state.fixedColumns = list;
        
    },

    removeFixedColumn(state, column) {
        let list = state.fixedColumns.slice(0);
        let index = list.indexOf(column);        
        list.splice(index, 1);
        state.fixedColumns = list;
    },

    setBodyRows(state, rows) {
        state.bodyRows = rows;
    },

    setHeaderRows(state, rows) {
        state.headerRows = rows;
    },

    setFooterRows(state, rows) {
        state.footerRows = rows;
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/table_v3/mutations.js